const routes = [
  {
    path: `/configurar-loja`,
    component: () => import("./views/Main.vue"),
    name: "Ajustes da Loja"
  },
  {
    path: `/minha-loja`,
    component: () => import("./views/MyStore.vue"),
    name: "Minha loja"
  },
];

export default {
  routes
};
